import { createApiAction } from '@app/packages/api/utils'
import type { ApiOnboarding, ApiOnboardingStep } from '@app/packages/api/v2/types/entities'

export const getSitterOnboarding = () =>
  createApiAction('getSitterOnboarding', dispatch =>
    dispatch<{ data: ApiOnboarding; included?: ApiOnboardingStep[] }>({ method: 'GET', endpoint: '/api/v2/sitter_onboarding' })
  )
